import AUDITORIAS_CONTRATOS from '@/graphql/querys/administracion/auditorias/auditoriasContratos.gql';
import AGREGAR_AUDITORIA_CONTRATO from '@/graphql/mutations/administracion/auditorias/contratos/agregarAuditoriaContrato.gql';
import REMOVER_AUDITORIA_CONTRATO from '@/graphql/mutations/administracion/auditorias/contratos/removerAuditoriaContrato.gql';

export default {
  methods: {
    async mixAgregarAuditoriaContrato() {
      this.mixEsCargando();
      this.enviandoFormulario = true;
      const { idAuditoria } = this;
      await this.$apollo
        .mutate({
          mutation: AGREGAR_AUDITORIA_CONTRATO,
          variables: { contrato: this.contrato },
          update: (store, { data: { agregarAuditoriaContrato } }) => {
            const data = store.readQuery(
              {
                query: AUDITORIAS_CONTRATOS,
                variables: {
                  idAuditoria,
                },
              },
            );
            data.auditoriasContratos.push(agregarAuditoriaContrato);
            store.writeQuery({ query: AUDITORIAS_CONTRATOS, data });
          },
        })
        .then(() => {
          this.mixMensajeSuccess();
        })
        .catch((err) => {
          this.mixMensajeError(err);
        });
      this.enviandoFormulario = false;
      this.mixEsCargando();
      this.cerrar();
    },
    async mixEliminarAuditoriaContrato() {
      this.mixEsCargando();
      this.enviadoFormulario = true;
      // const { idContrato } = this.auditoriaContratosEliminar;
      const { idAuditoria } = this.auditoriaContratosEliminar;
      const idAuditoriaContrato = this.auditoriaContratosEliminar.id;
      await this.$apollo.mutate({
        mutation: REMOVER_AUDITORIA_CONTRATO,
        variables: {
          id: idAuditoriaContrato,
        },
        update: (store) => {
          const query = {
            query: AUDITORIAS_CONTRATOS,
            variables: { idAuditoria },
          };
          const data = store.readQuery(query);
          const index = data.auditoriasContratos
            .findIndex(({ id }) => id === idAuditoriaContrato);
          if (index !== -1) {
            data.auditoriasContratos.splice(index, 1);
          }
          store.writeQuery({ ...query, data });
        },
      }).then(() => {
        this.mixMensajeSuccess();
      }).catch((err) => {
        this.mixMensajeError(err);
      });
      this.enviandoFormulario = false;
      this.mixEsCargando();
      this.cerrar();
    },
  },
};
